import React from 'react';

import CashAppProvider from '../../../checkout/components/CashAppProvider/CashAppProvider';
import PsourceProvider from '../../../checkout/components/PsourceProvider/PsourceProvider';

import checkoutModule from './checkoutModule';

export default function checkoutExtension() {
  return {
    id: 'checkout',
    server: process.browser
      ? undefined
      : {
          init() {
            require('./config');
          },
        },
    app: {
      render(props, children) {
        return (
          <PsourceProvider>
            <CashAppProvider>{children}</CashAppProvider>
          </PsourceProvider>
        );
      },
    },
    page(options) {
      return {
        async getInitialProps(ctx) {},
      };
    },
    redux: {
      modules: [checkoutModule],
    },
  };
}
